var render, staticRenderFns
import script from "./ListaItensTabela.vue?vue&type=script&lang=js"
export * from "./ListaItensTabela.vue?vue&type=script&lang=js"
import style0 from "./ListaItensTabela.vue?vue&type=style&index=0&id=c9185ad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports